export default __webpack_public_path__ + "static/media/aeroland-branding-picture-02.1cf36f56.png";